import { combine } from 'react-hooks-combine'
import { withRouter } from 'react-router-dom'

import LayoutComponent from './component'

export default combine({
  hocs: [withRouter],
  transformPropsBefore: ({ location, ...rest }) => {
    const skipRoutes = ['user-data-deletion-request']
    const isMenuHidden = skipRoutes.some((skippedItem) =>
      location.pathname.includes(skippedItem)
    )

    return {
      location,
      isMenuHidden,
      ...rest,
    }
  },
})(LayoutComponent)
